import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { animalKeys } from '../queries/keys';
import { animalPaths } from '../queries/paths';

// Co-propiedad de una donadora (admin-animal-ownerships.md, 0043). Σ percent ≤ 100
// (el resto es de la planta). POST hace find-or-update por (animal, client).
export function useAnimalOwners(animalId, opts = {}) {
    return useQuery({
        queryKey: animalKeys.owners(animalId),
        queryFn:  ({ signal }) => api.get(animalPaths.owners(animalId), { signal }).then(r => r.data),
        enabled:  !!animalId,
        ...opts,
    });
}

export function useAddOwner(animalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(animalPaths.owners(animalId), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: animalKeys.owners(animalId) }),
    });
}

export function useUpdateOwner(animalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ ownerId, ...payload }) => api.patch(animalPaths.owner(animalId, ownerId), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: animalKeys.owners(animalId) }),
    });
}

export function useDeleteOwner(animalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (ownerId) => api.delete(animalPaths.owner(animalId, ownerId)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: animalKeys.owners(animalId) }),
    });
}
